import React from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
interface NavProps extends BaseCompProps {
  attr?: any;
  step?: number;
}
const { useTranslation } = Hooks;
const Nav: React.FC<NavProps> = ({ className, step = 0 }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <div className={cx(styles["page-account-enterprise-nav"], className)}>
      <div className={cx(styles["iDiv"], step >= 1 && styles["atv"])}>
        <div>1</div>
        <span>{t("ent.baseInfo")}</span>
      </div>
      <div className={cx(styles["iLine"], step >= 1 && styles["atv"])}></div>
      <div className={cx(styles["iDiv"], step >= 2 && styles["atv"])}>
        <div>2</div>
        <span>{t("ent.memberInfo")}</span>
      </div>
      <div className={cx(styles["iLine"], step >= 2 && styles["atv"])}></div>
      <div className={cx(styles["iDiv"], step >= 3 && styles["atv"])}>
        <div>3</div>
        <span>{t("ent.qualification")}</span>
      </div>
      <div className={cx(styles["iLine"], step >= 3 && styles["atv"])}></div>
      <div className={cx(styles["iDiv"], step >= 4 && styles["atv"])}>
        <div>4</div>
        <span>{t("ent.checkIn")}</span>
      </div>
    </div>
  );
};
export default observer(Nav);
